/**
 * Various useful functions
 */
export class MiscHlp {
  /**
   * generate string of given length, composed of numbers and small letters
   * @param {number} length
   * @return {string} string of given length if length > 0; else most probably [9-12] chars
   */
  public static randomString(length = 0): string {
    let str = '';

    do str += Math.random().toString(36).substring(2);
    while (str.length < length);

    return length > 0 ? str.substring(str.length - length) : str;
  }

  /**
   * Why on earth would I want to uste this?! E.g. to serialize JSON in unified form to easier use of diff tools \
   * HACK This is absolutly awful - but works
   *
   * !!! DON'T USE IN PRODUCTION CODE !!!
   * @param {T} object
   * @return {T} identic object, but with all properties sorted alfabethically recursivly
   */
  public static sortObject<T>(object: T): T {
    return JSON.parse(JSON.stringify(object), (key, value) => (typeof value == 'object' ? MiscHlp.sortProperties(value) : value));
  }

  /**
   * Sorts object's poroperties alfabethically
   * @param {T} x
   * @return {T} identic object, but with all properties sorted alfabethically
   * @why check MiscHlp.sortObject()
   *
   *            !!! DON'T USE IN PRODUCTION CODE !!!
   */
  public static sortProperties<T extends Record<string, unknown>>(x: T): T {
    return Object.fromEntries(Object.entries(x).sort((a, b) => a[0].localeCompare(b[0]))) as T;
  }
}
